import CircleIcon from '@mui/icons-material/Circle';
import { IconButton } from "@mui/material";
import { useState } from "react";
import { usePrivacy } from "providers/PrivacyProvider";
import { usePasskeyAuthentication } from "hooks/usePasskeyAuthentication";

const PrivacyToggle = () => {
  const { privateMode, unlockPrivate, lockPrivate } = usePrivacy();
  const { authenticate } = usePasskeyAuthentication();
  const [isLoading, setIsLoading] = useState(false);
  let taskbarPrivacyIndicatorClassName = 'taskbar__icon taskbar__privacy-indicator';
  if (!privateMode) taskbarPrivacyIndicatorClassName += ' taskbar__privacy-indicator--public';
  else taskbarPrivacyIndicatorClassName += ' taskbar__privacy-indicator--private';

  const togglePrivacy = async () => {
    if (isLoading) return;
    if (privateMode) {
      lockPrivate();
      return;
    }
    try {
      setIsLoading(true);
      const result = await authenticate();
      if (result.success) unlockPrivate();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <IconButton onClick={togglePrivacy} disabled={isLoading}>
      <CircleIcon className={taskbarPrivacyIndicatorClassName} />
    </IconButton>
  );
};

export default PrivacyToggle;